import axios from "axios";
import {getToken} from "@/api/config/token"
import {getSimplesNacionalURL} from "@/api/config/init"

const service = axios.create({
    baseURL: getSimplesNacionalURL(),
    timeout: 900000
});

// request interceptor
service.interceptors.request.use(
    config => {
        config.headers['Authorization'] = `Bearer ${getToken()}`;
        return config
    },
    error => {
        return Promise.reject(error)
    }
);

service.interceptors.response.use(
    response => {
        const {data} = response;
        return data
    },
    error => {
        if (typeof error.response === "undefined") {
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

export default service
